module.exports = __webpack_public_path__ + "assets/img/rp-team.eac70f62.png";